import Vue from 'vue'
import Router from 'vue-router'
// Containers
import Full from '@/containers/Full'
// Views
import Dashboard from '@/views/Dashboard'

import User from '@/views/user/base'
import Permission from '@/views/admin/Permissions'
import Auditlog from '@/views/admin/Auditlog'
import Pokemon from '@/views/pokemon/'
import PokemonAdd from '@/views/pokemon/PokemonAdd'
import Inventory from '@/views/user/inventory'
import Variables from '@/views/user/variables'
import Pokedex from '@/views/user/pokedex'
import Connections from '@/views/user/connections'
import Tradelog from '@/views/user/tradelog'
import PVPlog from '@/views/user/pvplog'
import Massban from '@/views/admin/Massban'
import SystemBans from '@/views/admin/SystemBans'
import Debug from '@/views/admin/Debug'
import Userlog from '@/views/userlog'
import Snapshots from '@/views/user/snapshots'
import ListNews from '@/views/news/List'
import CreateNews from '@/views/news/Create'
import EditNews from '@/views/news/Edit'
import IngameNews from '@/views/news/Ingame'
import PvpRules from '@/views/news/PvpRules'
import PvpRewards from '@/views/news/PvpRewards'
import PvpBanlist from '@/views/pvp/Banlist.vue'
import PvpUsageStats from '@/views/pvp/UsageStats.vue'
import RandomSets from '@/views/pvp/RandomSets.vue'
import GlobalVars from '@/views/globalvars/'
import ScriptErrors from '@/views/scripterrors/'
import History from '@/views/user/history'
import Chatlog from '@/views/chatlog'
import Guild from '@/views/user/guild'
import Watchlist from '@/views/gm/watchlist'
import Playtime from '@/views/gm/Playtime'
import ToolsLog from '@/views/admin/ToolsLog'
import EmailBounces from '@/views/admin/EmailBounces'
import EmailRouting from '@/views/admin/EmailRouting'
import ViewSnapshot from '@/views/user/snapshot'
import SuspectMatches from '@/views/gm/suspect_matches.vue'
// Views - Pages
import Page404 from '@/views/pages/Page404'
import Login from '@/views/pages/Login'
import store from '../store'
import Permissions from '../_permissions'
import Ladder from '@/views/ladder/';

import UserDashboard from '@/views/user/UserUnifiedDashboard';
import MacroDetails from '@/views/user/base/MacroDetails';

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => {
    const msg = err && err.message ? err.message : ''
    if (err && (err.name === 'NavigationDuplicated' || msg.includes('Redirected when going from'))) {
      return err
    }
    throw err
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch((err) => {
    const msg = err && err.message ? err.message : ''
    if (err && (err.name === 'NavigationDuplicated' || msg.includes('Redirected when going from'))) {
      return err
    }
    throw err
  })
}

const BASE_TITLE = 'Modtools'

const router = new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      beforeEnter: requireAuth,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          beforeEnter: requireAuth
        },
        {
          path: 'userlog',
          name: 'Userlog',
          component: Userlog,
          beforeEnter: requireAuth
        },
        {
          path: 'pokemon',
          name: 'Pokemon',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Pokemon Search',
              component: Pokemon,
              beforeEnter: requireAuth
            },
            {
              path: 'add',
              name: 'Pokemon Generator',
              component: PokemonAdd,
              beforeEnter: requireAuth
            }
          ]
        },
        {
          path: 'globalvars',
          name: 'Global Vars',
          component: GlobalVars,
          beforeEnter: requireAuth
        },
        {
          path: 'script-errors',
          name: 'Script Errors',
          component: ScriptErrors,
          beforeEnter: requirePermission('ScriptErrorsView')
        },
        {
          path: 'pvp',
          name: 'PvP',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'ladder',
              name: 'Ladder',
              component: Ladder,
              beforeEnter: requireAuth
            },
            {
              path: 'usage_stats',
              name: 'Usage Stats',
              component: PvpUsageStats,
              beforeEnter: requirePermission('PvpUsageStatsView')
            },
            {
              path: 'rules',
              name: 'PvP Rules',
              component: PvpRules,
              beforeEnter: requireAuth
            },
            {
              path: 'rewards',
              name: 'PvP Rewards',
              component: PvpRewards,
              beforeEnter: requireAuth
            },
            {
              path: 'banlist',
              name: 'PvP Banlist',
              component: PvpBanlist,
              beforeEnter: requireAuth
            },
            {
              path: 'random_sets',
              name: 'Random Sets',
              component: RandomSets,
              beforeEnter: requireAuth
            },
            {
              path: 'suspect_matches',
              name: 'Suspect Matches',
              component: SuspectMatches,
              beforeEnter: requireAuth
            }
          ]
        },
        {
          path: 'admin',
          name: 'Admin',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'permission',
              name: 'Permission',
              component: Permission,
              beforeEnter: requireAuth
            },
            {
              path: 'auditlog',
              name: 'Auditlog',
              component: Auditlog,
              beforeEnter: requireAuth
            },
            {
              path: 'toolslog',
              name: 'ToolsLog',
              component: ToolsLog,
              beforeEnter: requireAuth
            },
            {
              path: 'MailLog',
              redirect: 'email-bounces'
            },
            {
              path: 'maillog',
              redirect: 'email-bounces'
            },
            {
              path: 'email-bounces',
              name: 'E-Mail Delivery',
              component: EmailBounces,
              beforeEnter: requirePermission('MailLogView')
            },
            {
              path: 'email-routing',
              name: 'E-Mail Routing',
              component: EmailRouting,
              beforeEnter: requirePermission('EmailRoutingView')
            },
            {
              path: 'chatlog',
              name: 'Chat log',
              component: Chatlog,
              beforeEnter: requireAuth
            },
            {
              path: 'massban',
              name: 'Massban',
              component: Massban,
              beforeEnter: requireAuth
            },
            {
              path: 'systembans',
              name: 'SystemBans',
              component: SystemBans,
              beforeEnter: requireAuth
            },
            {
              path: 'debug',
              name: 'Debug',
              component: Debug,
              beforeEnter: requireAuth
            }
          ]
        },
        {
          path: 'news',
          name: 'News',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'News',
              component: ListNews,
              beforeEnter: requireAuth
            },
            {
              path: 'create',
              name: 'Write News',
              component: CreateNews,
              beforeEnter: requireAuth
            },
            {
              path: 'edit/:id',
              name: 'Edit News',
              component: EditNews,
              beforeEnter: requireAuth
            },
            {
              path: 'ingame',
              name: 'Ingame News',
              component: IngameNews,
              beforeEnter: requireAuth
            }
          ]
        },
        {
          path: 'gm',
          name: 'GM',
          component: {
            render (c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'watchlist',
              name: 'Watchlist',
              component: Watchlist,
              beforeEnter: requireAuth
            },
            {
              path: 'playtime',
              name: 'Playtime',
              component: Playtime,
              beforeEnter: requireAuth
            },
          ]
        },
        {
          path: '/user/:username/macro',
          name: 'MacroDetails',
          component: MacroDetails,
          beforeEnter: requireAuth
        },
        {
          path: '/user/:username/snapshot/:id',
          name: 'Snapshot',
          component: ViewSnapshot,
          beforeEnter: requireAuth
        },
        {
          path: '/user/:username/:tab?',
          name: 'User',
          component: UserDashboard,
          beforeEnter: requireAuth
        }
      ]
    },
    {
      path: '/auth',
      name: 'Auth',
      component: {
        render (c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    },
    {path: '*', component: Page404}

  ]
})

function formatTabTitle(tab) {
  if (!tab) return ''
  return tab
    .toString()
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

router.afterEach((to) => {
  const title = to.meta && to.meta.title ? to.meta.title : to.name
  const username = to.params && to.params.username ? to.params.username : ''
  const isUserPage = to.name === 'User'
  if (title) {
    if (username) {
      const tab = formatTabTitle(to.params && to.params.tab ? to.params.tab : 'profile')
      if (isUserPage) {
        document.title = `${username}${tab ? ` | ${tab}` : ''} | ${BASE_TITLE}`
      } else {
        document.title = `${title} | ${username}${tab ? ` | ${tab}` : ''} | ${BASE_TITLE}`
      }
    } else {
      document.title = `${title} | ${BASE_TITLE}`
    }
  } else {
    document.title = BASE_TITLE
  }
})

export default router

function findPermission (name) {
  for (let category in Permissions) {
    for (let permission in Permissions[category].Permissions) {
      if (permission === name) {
        return Permissions[category].Permissions[permission].Permission
      }
    }
  }
  return null
}

function userHasPermission (name) {
  const user = store.getters.authUser
  const permission = findPermission(name)
  if (!user || !permission) return false
  if (permission.and(user.deny).neq(0)) return false
  if (permission.and(user.allow).neq(0)) return true
  return permission.and(user.permission).neq(0)
}

function requirePermission (permissionName) {
  return function (to, from, next) {
    const verify = () => {
      if (store.getters.authUser && userHasPermission(permissionName)) {
        next()
        return
      }
      if (store.getters.authUser === null && !store.getters.authPending) {
        next({
          path: '/auth/login',
          query: { redirect: to.fullPath }
        })
        return
      }
      next('/dashboard')
    }

    if (store.getters.authUser || !store.getters.authPending) {
      verify()
      return
    }

    const unwatch = store.watch(
      state => state.socket.user,
      () => {
        unwatch()
        verify()
      }
    )
  }
}

function requireAuth(to, from, next) {
  if (store.getters.authUser) {
    next()
  } else if (store.getters.authPending) {
    next()
  } else if (store.getters.authUser === null) {
    const unwatch = store.watch(
      state => state.socket.user,
      val => {
        unwatch()
        if (store.getters.authUser) {
          next()
        } else {
          next({
            path: '/auth/login',
            query: { redirect: to.fullPath }
          })
        }
      }
    )
  } else {
    next({
      path: '/auth/login',
      query: { redirect: to.fullPath }
    })
  }
}
